import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Progress} from 'reactstrap';

import {
  selectors as autoLogoutSel,
} from 'App/util/redux/autoLogout/index';

import {
  selectors as authSel,
} from 'App/util/redux/auth/index';

// get redux store
const mapStateToProps = (state) => ({
  percentageLeft: autoLogoutSel.percentage(state),
  timeLeft: autoLogoutSel.value(state),
  user: authSel.user(state),
});

@connect(
  mapStateToProps
)
class CountDown extends Component {
  timeLeft() {
    const minutes = Math.floor(this.props.timeLeft / 60);
    const n = (n) => n > 9 ? '' + n : '0' + n;

    return {
      minute: minutes,
      second: n(Math.floor(this.props.timeLeft - minutes * 60))
    }
  }

  render() {
    return (
      <div id="countdown">
        <Progress color="info" value={this.props.percentageLeft}>
          {this.timeLeft().minute + ':' + this.timeLeft().second}
        </Progress>
      </div>
    );
  }
}

export default CountDown;


// WEBPACK FOOTER //
// ./src/components/CountDown/CountDown.js